import { render, staticRenderFns } from "./OrderDetailManager.vue?vue&type=template&id=86ba6cf4"
import script from "./OrderDetailManager.js?vue&type=script&lang=js&external"
export * from "./OrderDetailManager.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports